<template>
    <div :class="selectedClasses" @click.stop="onSelectComponent"
         @mouseover.stop="isMouseOver = true" @mouseout.stop="isMouseOver = false">
        <button :class="component.classes">
            {{ component.text }}
        </button>
    </div>
</template>

<script>
import ComponentManager from "../utils/ComponentManager";
import webase from "../app/model";
import ButtonStyleFactory from "../factories/ButtonStyleFactory";
import webaseConstants from "../constants";

export default {
    name: 'ButtonComponent',
    props: ['component', 'editorState', 'parentComponent', 'layer'],
    computed: {
        selectedClasses() {
            if (this.editorState.selectedComponent === this || this.isMouseOver) {
                return this.model.highlightClasses
            }

            return 'p-1'
        },
        currentTheme() {
            return this.editorState.theme.metadata
        }
    },
    watch: {
        'editorState.theme'(newTheme, oldTheme) {
            if(newTheme === null) {
                this.removeExistingColorClasses()
                return
            }

            this.applyTheme()
        },
        'component.theme'(newButtonTheme, oldButtonTheme) {
            if(!newButtonTheme) {
                this.removeExistingColorClasses()
            }
            else if(newButtonTheme !== oldButtonTheme) {
                this.applyButtonTheme(newButtonTheme)
            }
        }
    },
    data() {
        return {
            model: webase.model,
            manager: new ComponentManager(this.component),
            isMouseOver: false
        }
    },
    mounted() {
        this.component.location = this.parentComponent ? `${this.parentComponent.location}.${this.index}` : `${this.index}`
        this.component.parent = this.parentComponent
    },
    methods: {
        onSelectComponent() {
            console.log('ButtonC.onSelectComponent')
            this.editorState.selectedComponent = this
            this.editorState.selectedComponentDefinition = this.component
            this.editorState.selectedComponentManager = this.manager
            // webase.eventDispatcher.emit('onButtonClicked')
        },
        applyTheme() {
            let themeName = this.component.theme ? this.component.theme : 'primary'
            this.applyButtonTheme(themeName)
        },
        applyButtonTheme(buttonThemeName) {
            this.removeExistingColorClasses()
            let buttonFactory = new ButtonStyleFactory()
            let buttonTheme = this.getButtonTheme(buttonThemeName)
            let cssClasses = buttonFactory.cssClasses(buttonTheme, this.currentTheme.buttonStyle)
            this.component.classes = this.component.classes.concat(cssClasses)
            this.component.theme = buttonThemeName
        },
        removeExistingColorClasses() {
            let classPrefixes = webaseConstants.buttonBgColorClasses
            this.component.classes = webase.utils.array.filterAll(this.component.classes, classPrefixes)
        },
        getButtonTheme(buttonThemeName) {
            if (this.editorState.theme.metadata.isLight) {
                return this.editorState.theme.metadata.buttons[buttonThemeName]
            }

            return this.editorState.theme.metadata.dark.buttons[buttonThemeName]
        }
    }
}
</script>
